export default __webpack_public_path__ + "static/media/mission-bg.cd95c655.webp";